import { useTranslations } from 'next-intl';
import {
  CatIconInfo,
  CatTooltip,
  CatTextPassage,
  CatButton
} from 'components/blocks-components';
import { TooltipPosition } from '@blocks-web-components/components/tooltip/tooltip.model';
import styles from './product-core-desposit.module.scss';
import cx from 'classnames';

interface ProductCoreDepositProps {
  coreCharges: string;
  currency: string;
  withBorder?: boolean;
  tooltipPosition?: TooltipPosition;
}

const TooltipTrigger = () => {
  const t = useTranslations();

  return (
    <CatButton
      variant="ghost"
      slot="trigger"
      className={styles['product-core-deposit__tooltip-trigger']}
    >
      <CatIconInfo className="me-1" color="information" />
      <span className="cat-u-theme-typography-label-sm">
        {t('CAT_CORE_DEPOSIT_TITLE')}
      </span>
    </CatButton>
  );
};

const ProductCoreDeposit = ({
  coreCharges,
  currency,
  withBorder = true,
  tooltipPosition = 'top'
}: ProductCoreDepositProps) => {
  const t = useTranslations();

  return (
    <div
      className={cx('d-flex flex-column', {
        'py-2': withBorder,
        [styles['product-core-deposit__container']]: withBorder
      })}
    >
      <CatTooltip
        isInteractive
        position={tooltipPosition}
        className={styles['product-core-deposit__tooltip']}
      >
        <TooltipTrigger />
        <CatTextPassage size="xs">
          <div
            className={cx(
              'd-flex flex-column',
              styles['product-core-deposit__tooltip-content']
            )}
          >
            <b>{t('CAT_CORE_DEPOSIT_TITLE')}</b>
            {t('CAT_CORE_UNIT_SELL')}
          </div>
        </CatTextPassage>
      </CatTooltip>
      <p className={cx('mt-1 mb-0', styles['product-core-deposit__price'])}>
        <span className="cat-u-theme-typography-label-sm">{coreCharges}</span>
        <span className="cat-u-theme-typography-footnote"> {currency}</span>
      </p>
    </div>
  );
};

export default ProductCoreDeposit;
